/* eslint-disable consistent-return */
/* eslint-disable max-len */

import { cleanHtml } from './common';

/**
 * Process the campaign raw data to a more screen friendly data.
 *
 * @author: Hesan
 * @param {object} discoveryData The raw campaign data
 * @returns {object}
 */
const discoveryReducer = (discoveryData) => {
  const {
    blog_articles,
    rf_lessons,
    misunderstood_materials,
    learning_modules,
  } = discoveryData;
  const reducedFundamentals = recyclingFundamentalsReducer(rf_lessons);
  const reducedLearningModules = learningModulesReducer(learning_modules);
  return {
    blogPosts: blogReducer(blog_articles),
    misundestoodMaterials: misundestoodMaterialsReducer(misunderstood_materials),
    recyclingFundamentals: reducedFundamentals,
    learningModules: reducedLearningModules,
  };
};

export const blogReducer = (posts) => posts.reduce((accumulator, {
  blog_id: id,
  body,
  image_path: image,
  title
}, index) => {
  const newObj = {
    id,
    body: cleanHtml(body),
    image,
    title,
    index
  };
  return {
    ...accumulator,
    [id]: newObj,
  };
}, {});

export const misundestoodMaterialsReducer = (materials) => materials.reduce((prev, {
  mat_id: id,
  mat_img: image,
  mat_nm: materialName,
  mat_cat_header: header,
  mat_cat_description: body
}, i) => {
  const newObj = prev;
  newObj[id] = newObj.id || id;
  newObj[id] = {
    id,
    image,
    materialName,
    header,
    body: cleanHtml(body),
    title: materialName,
    oidx: i,
    done: false,
    isLastItem: i === materials.length - 1,
  };
  return newObj;
}, {});

export const recyclingFundamentalsReducer = (lessons) => lessons
  .reduce((prev, {
    campaign_id,
    campaign_coachable_id,
    activities,
    title
  }, i) => {
    const newObj = prev;
    newObj[campaign_id] = newObj.id || campaign_id;
    newObj[campaign_id] = {
      id: campaign_id,
      activityId: campaign_coachable_id,
      oidx: i,
      title,
      activity: activities[0],
      done: false,
      progress: {},
      isLastItem: i === lessons.length - 1,
    };
    return newObj;
  }, {});

export const learningModulesReducer = (lessons) => lessons?.map((_, index) => lessons[index].videos
  .reduce((prev, {
    campaign_id,
    coachable_id,
    video_link,
    message,
    video_title
  }, i) => {
    const newObj = prev;
    newObj[coachable_id] = newObj.id || coachable_id;
    newObj[coachable_id] = {
      id: campaign_id,
      activityId: coachable_id,
      oidx: i,
      title: video_title,
      activity: {
        type: 'video',
        coachable_id,
        video_link,
        message
      },
      done: false,
      progress: {},
      isLastItem: i === lessons[0].videos.length - 1,
    };
    return newObj;
  }, {}));

export default discoveryReducer;
